// extracted by mini-css-extract-plugin
export default {"leftContent":"index_leftContent_KBrW7","artical":"index_artical_sN48a","cmt":"index_cmt_BGbwY"};